// TEMPORARY dev-only tracing for the fulfillment-reset investigation.
// Logs every mutation of fulfillment state with its source, so a single
// reproduction names the exact code path that flips a scheduled slot back to
// today/ASAP. Strip once the bug is confirmed fixed.
const enabled = () => {
  try {
    return import.meta.env.DEV || sessionStorage.getItem('fulfillmentDebug') === '1';
  } catch {
    return import.meta.env.DEV;
  }
};

export const fdebug = (source, message, data) => {
  if (!enabled()) return;
  // Single line, greppable, with the slot fields pulled out for readability.
  const slot = data && typeof data === 'object'
    ? ` date=${data.date ?? '-'} time=${data.time ?? '-'} asap=${data.asap ?? '-'}`
    : '';
  // console.debug(`[fulfillment] ${source}: ${message}${slot}`, data ?? '');
};
